<template>
    <q-input
        v-model="internalValue"
        dense
        outlined
        :name="name"
        v-bind="$attrs"
    >
        <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope || {}"></slot>
        </template>
    </q-input>
</template>

<script>
import { ref, watch } from "vue";

export default {
    name: "InputWrapper",
    props: {
        modelValue: [String, Number],
        name: String,
    },
    setup(props) {
        const internalValue = ref(props.modelValue);

        watch(
            () => props.modelValue,
            (val) => {
                internalValue.value = val;
            },
        );

        return { internalValue };
    },
};
</script>
